module.exports = __webpack_public_path__ + "img/20.e2737fb4.jpg";